/**
 * Whether the visitor explicitly chose a language — clicked the language
 * switcher, or arrived on a ?lang= link (hreflang alternates). Only then
 * does their language beat the store's default locale.
 *
 * i18next's detector caches whatever it detected (often just the browser
 * locale) to localStorage on first load, so "something is stored" cannot
 * mean "the visitor chose it"; this separate flag does.
 */
const KEY = 'storefront.languageChosen';

export function markLanguageChosen() {
  try { localStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked: session-only choice */ }
}

export function hasChosenLanguage() {
  try {
    // Arriving on a ?lang= link is a choice that should outlive this URL.
    if (new URLSearchParams(window.location.search).has('lang')) {
      markLanguageChosen();
      return true;
    }
    return localStorage.getItem(KEY) === '1';
  } catch (e) {
    return false;
  }
}
